import { gql, useQuery } from '@apollo/client'

const GET_STUDENTS = gql`
  query CoachStudents {
    coachStudents {
      id
      isMinor
      firstName
      lastName
      hasAccount
      representatives {
        relationshipType
        contact {
          externalId
          email
          phone
        }
      }
    }
  }
`

export function useGetStudents() {
  return useQuery(GET_STUDENTS, {
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
  })
}

const UPCOMING_SESSIONS = gql`
  query UpcomingSessions(
    $startDateTime: DateTimeRangeInput!
    $orderBy: [ScheduleOrderByInput!]!
  ) {
    currentUser {
      schedule(startDateTime: $startDateTime, orderBy: $orderBy) {
        __typename
        id
        startDateTime
        endDateTime
        timezone
        isCanceled
        title
        description
        startDateTime
        coach {
          name
          id
        }
        coachFacility {
          name
          street
          city
          state
          zipCode
          name
          street
          city
          state
          zipCode
        }
        enrollments {
          id
          confirmationCode
          createdAt
          isCanceled
          lessonCredit {
            lessonPack {
              id
              lessonPackOffering {
                pricePerLessonInCents
              }
              registrationPayments {
                id
                createdAt
              }
            }
          }
          student {
            id
            firstName
            lastName
            representatives {
              contact {
                externalId
                firstName
                lastName
                email
                phone
              }
            }
            contact {
              id
              firstName
              lastName
              email
              phone
              externalId
            }
          }
          transactions {
            amountInCents
            createdAt
            sourceType
            refund
            registrationPayment {
              id
              leftToRefundInCents
            }
          }
        }
        ... on Session {
          lessonType {
            id
            category
            priceInCents
            acceptsOnlinePayments
            durationInMinutes
            paymentAccount {
              deletedAt
              chargesEnabled
              payoutsEnabled
            }
          }
        }
        ... on GroupEvent {
          slug
          tags
          featuredImageUrl
          priceInCents
          totalPriceInCents
          acceptsOnlinePayments
          paymentRecurrenceSchedule
          numberOfPayments
          lessonCount
          registrationCloseDateTime
          externalRegistrationUrl
          registrationCount
          paymentAccount {
            deletedAt
            chargesEnabled
            payoutsEnabled
          }
          sessions {
            id
            startDateTime
            endDateTime
          }
        }
      }
    }
  }
`

export function useGetUpcomingSessions(start, order) {
  return useQuery(UPCOMING_SESSIONS, {
    variables: {
      startDateTime: start,
      orderBy: [{ field: 'START_DATE_TIME', direction: order }],
    },
  })
}
